import { cn } from "@monorepo-apps/ui/src/lib/utils";

import type { Progress } from "@/application/use-cases/b2c/build-b2c-board";
import { ITERATION_BAR_CLASS } from "@/presentation/data/b2c-board";
import type { IterationStatus } from "@/infrastructure/supabase/b2c-board.types";

/** A thin progress bar with the done/total count and the percentage. */
export function MarathonProgress({
  progress,
  status,
  className,
}: {
  progress: Progress;
  status: IterationStatus;
  className?: string;
}) {
  const pct = Math.round(progress.ratio * 100);
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <div
        className="bg-muted h-1.5 flex-1 overflow-hidden rounded-full"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label={`${progress.done} of ${progress.total} tasks done`}
      >
        <div
          className={cn("h-full rounded-full transition-[width]", ITERATION_BAR_CLASS[status])}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="font-data text-muted-foreground shrink-0 text-[11px] tabular-nums">
        {progress.done}/{progress.total} · {pct}%
      </span>
    </div>
  );
}
